import React, { useState } from 'react';
import { useAuth } from '../../components/auth/AuthProvider';
import UserManagement from '../../components/admin/UserManagement';
import './AdminDashboard.css';

const AdminDashboard = () => {
  const { user } = useAuth();
  const [activeTab, setActiveTab] = useState('users');

  const tabs = [
    { id: 'users', label: 'Utilisateurs', component: UserManagement },
    { id: 'roles', label: 'Rôles', component: () => <div>Gestion des rôles - En développement</div> },
    {
      id: 'permissions',
      label: 'Permissions',
      component: () => <div>Gestion des permissions - En développement</div>,
    },
    { id: 'settings', label: 'Paramètres', component: () => <div>Paramètres système - En développement</div> },
  ];

  const ActiveComponent = tabs.find((tab) => tab.id === activeTab)?.component;

  return (
    <div className="admin-dashboard">
      <div className="admin-header">
        <h1>Tableau de bord Administrateur</h1>
        <div className="admin-user-info">
          <span>Connecté en tant que: {user?.email}</span>
        </div>
      </div>

      <div className="admin-content">
        <div className="admin-sidebar">
          <nav className="admin-nav">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                className={`nav-item ${activeTab === tab.id ? 'active' : ''}`}
                onClick={() => setActiveTab(tab.id)}
              >
                {tab.label}
              </button>
            ))}
          </nav>
        </div>

        <div className="admin-main">
          <div className="admin-main-content">{ActiveComponent && <ActiveComponent />}</div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
